export class CostWaiverDisabled extends Error {
  constructor(message: string) {
    super(message)
    Object.setPrototypeOf(this, CostWaiverDisabled.prototype)
  }
}
